export const sameInstant = (left: string, right: string): boolean => {
  const leftInstant = Date.parse(left);
  return Number.isFinite(leftInstant) && leftInstant === Date.parse(right);
};
